import React from "react";
// import ATMLoadingButton from "src/components/UI/atoms/ATMLoadingButton/ATMLoadingButton";
import ATMPageHeader from "src/components/UI/atoms/ATMPageHeader/ATMPageHeader";
import ATMPagination from "src/components/UI/atoms/ATMPagination/ATMPagination";
import ATMTable, {
  columnTypes,
} from "src/components/UI/atoms/ATMTable/ATMTable";
import ATMDatePicker from "src/components/UI/atoms/formFields/ATMDatePicker/ATMDatePicker";
import SideNavLayout from "src/components/layouts/SideNavLayout/SideNavLayout";
// import { setDateFilter } from "src/redux/slices/PaymentSlice";

// import { CSVLink } from "react-csv";

import PaymentFilterDialogWrapper from "./FilterDialog/PaymentFilterDialogWrapper";

type Props = {
  columns: columnTypes[];
  getPaymentExcel: any;
  isloadingExcel: boolean;
  rows: any[];
  // excelData: any[];
  paginationProps: {
    isTableLoading: boolean;
    totalItems: number;
    page: number;
    rowsPerPage: number;
    searchValue: string;
    setPage: (newPage: number) => void;
    setRowsPerPage: (newLimit: number) => void;
    setSearchValue: (newValue: string) => void;
  };
};

const PaymentListing = ({
  columns,
  rows,
  // excelData,
  getPaymentExcel,
  isloadingExcel,
  paginationProps: {
    isTableLoading,
    totalItems,
    page,
    rowsPerPage,
    searchValue,
    setPage,
    setRowsPerPage,
    setSearchValue,
  },
}: Props) => {
  const [openFilterDialog, setOpenFilterDialog] =
    React.useState<boolean>(false);

  // const dispatch = useDispatch();
  //   const flatData = rows?.reduce((result, entry) => {
  //     entry.paymentMode.forEach((paymentMode: any) => {
  //       const flatEntry = {
  //         ...entry,
  //         paymentModeName: paymentMode.paymentModeName,
  //         amount: paymentMode.amount,
  //       };
  //       delete flatEntry.paymentMode;
  //       result.push(flatEntry);
  //     });
  //     return result;
  //   }, []);

  return (
    <SideNavLayout>
      <div className="flex flex-col h-full p-4">
        {/* Page Header */}
        <div className="p-4">
          <ATMPageHeader
            moduleName="PAYMENT"
            pageTitle="Payments"
            searchValue={searchValue}
            isFilter
            onFilterClick={() => setOpenFilterDialog(true)}
            onSearchChange={setSearchValue}
            hideAddButton
          />
        </div>

        <div className="flex justify-between items-center mx-3 my-1  mb-4">
          <div>
            {/* <div className="flex justify-end items-center ">
                            <div className="flex gap-2  items-center">
                                <div className="min-w-[200px] max-w-[200px]">
                                    <ATMDatePicker
                                        name=""
                                        value={dateFilter.start_date}
                                        onChange={(value) => {
                                            dispatch(
                                                setDateFilter({ ...dateFilter, start_date: value })
                                            );
                                        }}
                                        label="Start Date"
                                    />
                                </div>

                                <div className="min-w-[200px] max-w-[200px]">
                                    <ATMDatePicker
                                        name=""
                                        value={dateFilter.end_date}
                                        onChange={(value) => {
                                            dispatch(
                                                setDateFilter({ ...dateFilter, end_date: value })
                                            );
                                        }}
                                        label="End Date"
                                        minDate={
                                            dateFilter.start_date
                                                ? new Date(dateFilter.start_date)
                                                : undefined
                                        }
                                    />
                                </div>
                                {dateFilter?.start_date || dateFilter?.end_date ? (
                                    <div>
                                        <button
                                            type="button"
                                            className={`rounded bg-primary-main text-white py-2 px-2 mt-4`}
                                            onClick={() => {
                                                dispatch(
                                                    setDateFilter({ start_date: null, end_date: null })
                                                );
                                            }}
                                        >
                                            Clear Date Filter
                                        </button>
                                    </div>
                                ) : null}
                            </div>
                        </div> */}
          </div>
        </div>
        {/* Table */}
        <div className="flex-1 overflow-auto flex flex-col">
          <ATMTable
            columns={columns}
            rows={rows}
            rowExtraClasses={() => "min-h-[40px]"}
            isLoading={isTableLoading}
          />
        </div>

        <div className="p-4 py-2">
          <ATMPagination
            page={page}
            rowsPerPage={rowsPerPage}
            onPageChange={setPage}
            onRowsPerPageChange={setRowsPerPage}
            rowCount={totalItems}
            rows={rows}
          />
        </div>
        {openFilterDialog ? (
          <PaymentFilterDialogWrapper
            onClose={() => {
              setOpenFilterDialog(false);
            }}
          />
        ) : null}
      </div>
    </SideNavLayout>
  );
};

export default PaymentListing;
